import React, { Component } from "react";
import { Button, ControlLabel, Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import uniqueId                       from 'lodash/uniqueId';
import LoaderButton                   from "../../components/LoaderButton";
import { invokeSaveBlockTemplate }    from '../../utils/AwsInvoke';
import DropdownBlockCategories        from "../../components/dropdown/DropdownBlockCategories";
import "../../css/modal/ModalSaveBlock.css";

export default class ModalSaveBlock extends Component {

    constructor(props) {
        super(props);

        var block_name = this.props.block_name
        if(this.props.block_name === null) block_name = "";

        this.state = {
            content: block_name,
            isLoading: false,
            error_msg: ""
        };
    }


    componentDidMount() {
        //block_id    = this.props.block_id;
        //block_name  = this.props.block_name;
        //console.log("block_id: " + block_id);
    }


    handleSubmit = async event => {
        this.setState({
            isLoading: true
        })
        var custom_name = this.state.content;
        var category_id = this.state.category_id;
        var block_id    = this.props.block_id;
        if(custom_name === "") {
            alert("Please Select or Add a Block Name.")
            return;
        }

        const results = await invokeSaveBlockTemplate(block_id, category_id, custom_name);

        if(results) {
            //this.props.handleSaveBlockTemplate(block_index, custom_name);

            // Close Modal //
            this.props.onHide();
        } else
            this.setState({
                error_msg: "Ooops, looks like there was an error. Try again.",
                isLoading: false
            })
    }

    handleCustomChange(event) {
        var name = event.target.value;
        this.setState({
            content: name
        })

    }

    getBlockCategory = (category_id) => {

        this.setState({
            category_id: category_id
        })
    }

    render() {
        return (
            <Modal
                show      = {this.props.show}
                onHide    = {this.props.onHide}
                className = ""
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title" className="fontSize26px">Save Block Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div>
                      &nbsp;Save a block to your block template library. Use the template  later at any time.
                      <br/><br/>

                      <div className="formLabelBody">Select a Block Category</div>
                      <div className="formLabelBody">
                          <DropdownBlockCategories
                              //id        = {this.state.category_id}
                              //category  = {this.state.category_name}
                              getBlockCategory={this.getBlockCategory}
                          />
                      </div>
                      <br/>

                      <div className="formLabelBody">Block Name</div>
                      <div className="formLabelBody">
                      <input type="text"
                             placeholder = "Block Name"
                             value     = {this.state.content}
                             onChange  = {this.handleCustomChange.bind(this)}
                             className = "input-lg blockNameField" />
                      </div>

                  </div>
                  { this.state.error_msg }
                  <br/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    { /*}<Button className="modalButtonOk" bsStyle="primary" onClick={() => this.handleCloseWin("delete")}>Ok</Button>*/ }
                    <LoaderButton
                        bsSize    = "large"
                        btncolor  = "#09c141"
                        height    = {38}
                        width     = {120}
                        isLoading = {this.state.isLoading}
                        text        = "Submit"
                        loadingText = ""
                        onClick     = {() => this.handleSubmit()}
                      />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalSaveBlock.js